/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_ContactInputs */

const en_footer_contact = /** @type {(inputs: Footer_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const zh_hans1_footer_contact = /** @type {(inputs: Footer_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联系我们`)
};

const pt_br2_footer_contact = /** @type {(inputs: Footer_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contato`)
};

const es_footer_contact = /** @type {(inputs: Footer_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacto`)
};

const fr_footer_contact = /** @type {(inputs: Footer_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const de_footer_contact = /** @type {(inputs: Footer_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

const ru_footer_contact = /** @type {(inputs: Footer_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контакты`)
};

const it_footer_contact = /** @type {(inputs: Footer_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contatti`)
};

/**
* | output |
* | --- |
* | "Contact" |
*
* @param {Footer_ContactInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const footer_contact = /** @type {((inputs?: Footer_ContactInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_ContactInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_footer_contact(inputs)
	if (locale === "pt-BR") return pt_br2_footer_contact(inputs)
	if (locale === "es") return es_footer_contact(inputs)
	if (locale === "fr") return fr_footer_contact(inputs)
	if (locale === "de") return de_footer_contact(inputs)
	if (locale === "ru") return ru_footer_contact(inputs)
	if (locale === "it") return it_footer_contact(inputs)
	return en_footer_contact(inputs)
});